import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

/* Local UI state for the cart drawer (open/close). The cart *data* lives in the
   Happyspace SDK (useRestaurantCart); this only controls the slide-over. */
interface CartUICtx {
  isCartOpen: boolean;
  openCart: () => void;
  closeCart: () => void;
  toggleCart: () => void;
}

const Ctx = createContext<CartUICtx | null>(null);

export function CartUIProvider({ children }: { children: ReactNode }) {
  const [isCartOpen, setOpen] = useState(false);
  const openCart = useCallback(() => setOpen(true), []);
  const closeCart = useCallback(() => setOpen(false), []);
  const toggleCart = useCallback(() => setOpen((v) => !v), []);
  const value = useMemo(() => ({ isCartOpen, openCart, closeCart, toggleCart }), [isCartOpen, openCart, closeCart, toggleCart]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCartUI(): CartUICtx {
  const v = useContext(Ctx);
  if (!v) return { isCartOpen: false, openCart: () => {}, closeCart: () => {}, toggleCart: () => {} };
  return v;
}
